export default "__VITE_ASSET__ae87d92e__"